import React from "react"
import { Script } from "gatsby"

/**
 * @returns Chartbeat script
 */

const ChartbeatScript = ({ article }) => {
  // Gatsby Cloud cannot destructure process.env
  const gatsbyLocalSite = process.env.GATSBY_LOCAL_SITE
  const { elements, canonicalUrl, authors, tags } = article

  const domainPrefix =
    gatsbyLocalSite.includes("localhost") || gatsbyLocalSite.includes("dev")
      ? "dev."
      : gatsbyLocalSite.includes("staging")
      ? "staging."
      : ""
  const authorName = authors && authors.length ? authors[0].name?.replace(/,/g, "") : ""
  const hasVideo = elements && elements.some(({ type }) => type === "video")

  return (
    <Script id="chartbeat-setup-script">{`
        (function() {
          var _sf_async_config = window._sf_async_config = (window._sf_async_config || {});
          _sf_async_config.uid = 56674;
          _sf_async_config.domain = '${domainPrefix}mindbodygreen.com';
          _sf_async_config.useCanonical = true;
          _sf_async_config.useCanonicalDomain = true;
          ${
            !canonicalUrl &&
            `
              _sf_async_config.useCanonical = false;
              _sf_async_config.useCanonicalDomain = false;
              _sf_async_config.path = window.location.pathname;
            `
          }
          ${tags && `_sf_async_config.sections = '${tags.join(", ")}';`}
          ${authorName && `_sf_async_config.authors = '${authorName}';`}

          function loadChartbeat() {
              var e = document.createElement('script');
              var n = document.getElementsByTagName('script')[0];
              e.type = 'text/javascript';
              e.async = true;
              e.src = '${
                hasVideo
                  ? "//static.chartbeat.com/js/chartbeat_video.js"
                  : "//static.chartbeat.com/js/chartbeat.js"
              }';
              n.parentNode.insertBefore(e, n);
          }

          loadChartbeat();
        })();
    `}</Script>
  )
}

export default React.memo(ChartbeatScript)
